import { Dialog } from '@mui/material';
import React, { useState } from 'react';
import useFetch from '../../../api/useFetch';
import {
  Category,
  ExoCalCategory,
} from '../../exo/cal/category/ExoCalCategory';
import LabeledBox from '../../special/LabeledBox';

export const TypeEventCategory = ({
  updateValidationOnChange,
  dataCollection,
  errors,
  field,
  size,
}) => {
  const { apiData, setApiData } = useFetch(`calendar-event-categories`);

  const [openCategories, setOpenCategories] = useState(false);

  return (
    <>
      <LabeledBox
        label={field.label}
        onClick={() => {
          if (dataCollection[field.key]) {
            updateValidationOnChange(field.key, null);
          } else {
            setOpenCategories(true);
          }
        }}
        size={size}
      >
        {dataCollection[field.key] && (
          <Category category={dataCollection[field.key]} disableSettings />
        )}
      </LabeledBox>
      <Dialog
        open={openCategories}
        onClose={() => setOpenCategories(false)}
        sx={{
          '.MuiPaper-root': {
            backgroundImage: 'unset!important',
          },
          '.MuiBackdrop-root': {
            backdropFilter: 'blur(1px)',
            backgroundColor: 'rgba(0, 0, 0, 0.3 )',
          },
        }}
      >
        <ExoCalCategory
          onSelect={(e) => {
            setOpenCategories(false);
            updateValidationOnChange(field.key, e);
          }}
          onClose={() => setOpenCategories(false)}
          categories={apiData}
          setCategories={setApiData}
        />
      </Dialog>
    </>
  );
};
